<template>
    <div>
        <component
            :is="component"
            v-for="(product, index) in offers"
            :key="product.offers?.[0].offerKey"
            :product="product"
            :search-request="searchRequest"
            :data-cy="`activity-offer-${index}`"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import ActivityCard from '@/components/activities/search/offers/ActivityCard.vue'
    import ActivityCardMobile from '@/components/activities/search/offers/ActivityCardMobile.vue'

    @Component({
        components: {
            ActivityCard,
            ActivityCardMobile,
        },
    })
    export class ActivityOffers extends Vue {
        @Prop({default: () => []}) offers

        get searchRequest() {
            return activitiesStore.searchRequest
        }

        get component() {
            return this.$breakpoint.smAndDown
                ? resolveComponent('ActivityCardMobile')
                : resolveComponent('ActivityCard')
        }
    }

    export default ActivityOffers
</script>
